<template>
  <v-hover>
    <template #default="{ isHovering, props: hoverProps }">
      <div v-bind="hoverProps" style="width:fit-content">
        <v-btn
          density="comfortable"
          size="small"
          color="grey"
          icon="mdi-delete"
          variant="text"
          :style="{ 'background-color': isHovering ? '#e0e0e0' : '' }"
          @click="dialog=true"
        />
      </div>
    </template>
  </v-hover>
  <SimpleCardDialog
    v-model:dialog="dialog"
    max-width="400"
    show-cancel
    :title="$t('ConfirmDelete')"
  >
    {{ $t('User.ConfirmDeleteAvatar') }}

    <template #actions>
      <ActionButton
        delete
        @click="destroy()"
      />
    </template>
  </SimpleCardDialog>
</template>

<script>
  import ActionButton from '@/components/parts/button/ActionButton'
  import SimpleCardDialog from '@/components/parts/dialog/SimpleCardDialog'

  export default {
    components: { SimpleCardDialog, ActionButton },
    mixins: [],
    props: {
      userId: {
        type: String,
        required: true
      }
    },
    emits: ['deleted'],
    data: () => ({
      dialog: false
    }),
    methods: {
      destroy () {
        this.$http.delete('user-avatar/' + this.userId + '/', {}).then((res) => {
          this.dialog = false
          setTimeout(() => {
            this.uploadLoading = false
            this.$emit('deleted')
          }, 500)
        })
      }
    }
  }
</script>

<style scoped>

</style>
